export const isNumber = (val: unknown): val is number => {
  return typeof val === 'number';
};

export const isString = (val: unknown): val is string => {
  return typeof val === 'string';
};

export const isNull = (val: unknown): val is null => {
  return val === null;
};

export const isObject = (val: unknown): val is Record<string, unknown> => {
  return typeof val === 'object' && !isNull(val) && !Array.isArray(val);
};

export const isValidDate = (val: string) => {
  return val !== 'Invalid Date';
};

export const hasContent = (val: unknown): val is string => {
  return isString(val) && val.trim() !== '';
};

export const isUndefined = (val: unknown): val is undefined => {
  return typeof val === 'undefined';
};

export const isFunction = (val: unknown): val is Function => {
  return typeof val === 'function';
};

export const getLast = <T>(list: T[]): T | undefined => {
  return list[list.length - 1];
};

// Type guard for `undefined` or `null` values
export function isNonNullable<T>(x: T | undefined | null): x is NonNullable<T> {
  // quick comparison with both undefined and null
  return x != null;
}

export function assertUnreachable(x: never): never {
  throw new Error(`assertUnreachable: Didn't expect to get here. Value: ${x}`);
}

export function assertExists<T>(x: T, errorMessage: string): asserts x is NonNullable<T> {
  // quick comparison with both undefined and null
  if (x == null) {
    throw new Error(`assertExists: "${errorMessage}"`);
  }
}
